import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.array.map";
import _classCallCheck from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
/**
 * body.tsx
 *
 * Forked from reactabular-table version 8.14.0
 * https://github.com/reactabular/reactabular/tree/v8.14.0/packages/reactabular-table/src
 */

import * as React from 'react';
import { isEqual, isFunction } from 'lodash';
import { resolveRowKey } from './resolve-row-key';
import { BodyRow } from './body-row';
import { ProviderContext } from './provider';

var BaseBody = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseBody, _React$Component);

  var _super = _createSuper(BaseBody);

  function BaseBody() {
    var _this;

    _classCallCheck(this, BaseBody);

    _this = _super.apply(this, arguments);

    _this.omitOnRow = function (props) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var onRow = props.onRow,
          ret = __rest(props, ["onRow"]);

      return ret;
    };

    return _this;
  }

  _createClass(BaseBody, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // Skip checking props against `onRow` since that can be bound at render().
      // That's not particularly good practice but you never know how the users
      // prefer to define the handler.
      // Check for wrapper based override.
      var renderers = nextProps.renderers;

      if (renderers && renderers.body && renderers.body.wrapper && renderers.body.wrapper.shouldComponentUpdate) {
        if (isFunction(renderers.body.wrapper.shouldComponentUpdate)) {
          return renderers.body.wrapper.shouldComponentUpdate.call(this, nextProps, {}, {});
        }

        return true;
      }

      return !isEqual(this.omitOnRow(this.props), this.omitOnRow(nextProps));
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          onRow = _a.onRow,
          rows = _a.rows,
          rowKey = _a.rowKey,
          columns = _a.columns,
          renderers = _a.renderers,
          props = __rest(_a, ["onRow", "rows", "rowKey", "columns", "renderers"]);

      var children = rows.map(function (rowData, index) {
        var key = resolveRowKey({
          rowData: rowData,
          rowIndex: index,
          rowKey: rowKey
        });
        return React.createElement(BodyRow, {
          key: key,
          renderers: renderers.body,
          onRow: onRow,
          rowKey: key,
          rowIndex: index,
          rowData: rowData,
          columns: columns
        });
      });
      return React.createElement(renderers.body.wrapper, props, children);
    }
  }]);

  return BaseBody;
}(React.Component);

BaseBody.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onRow: function onRow() {
    return Object;
  }
};
export var Body = function Body(props) {
  return React.createElement(ProviderContext.Consumer, null, function (_ref) {
    var columns = _ref.columns,
        renderers = _ref.renderers;
    return React.createElement(BaseBody, Object.assign({
      columns: columns,
      renderers: renderers
    }, props));
  });
};